module.exports = __webpack_public_path__ + "static/media/iroll.8d620176.svg";